import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import upArrow from "@assets/images/arrow-up.svg";

const Button = () => {
    const [isAtBottom, setIsAtBottom] = useState(false);

    // Define the scroll threshold (in pixels) to trigger button visibility
    const scrollThreshold = 300; // Adjust this value as needed

    // Detect when user scrolls and check if they have passed the threshold
    const handleScroll = () => {
        if (window.scrollY > scrollThreshold) {
            setIsAtBottom(true);
        } else {
            setIsAtBottom(false);
        }
    };

    // Scroll to top function
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div>
            {/* Only show the button if the user is at the bottom */}
            {isAtBottom && (
                <button className='scrollButton' onClick={scrollToTop} >
                    <img className='scrollButtonUpArrow' src={upArrow} />
                </button>
            )}
        </div>
    );

};

export default Button;

